import { createContext, PropsWithChildren } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormProvider } from '../forms/FormProvider';
import { ModelContext } from './ModelProvider';
import { useRhinoDevtoolsEmit } from '../../hooks/dev';
import { RhinoResource } from '../../index';

// Dynamic controller-state bag; consumers read many runtime fields.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ModelShowContextValue = Record<string, any>;

export const ModelShowContext = createContext<
  ModelShowContextValue | undefined
>(undefined);

interface ModelShowProviderProps {
  methods: UseFormReturn;
  model?: RhinoResource;
  [key: string]: unknown;
}

export const ModelShowProvider = ({
  children,
  ...props
}: PropsWithChildren<ModelShowProviderProps>) => {
  const { methods, ...context } = props;
  const { model } = context;

  useRhinoDevtoolsEmit({ type: 'ModelShowContext', context });

  return (
    <ModelContext value={{ model }}>
      <ModelShowContext value={{ ...props }}>
        <FormProvider {...methods}>{children}</FormProvider>
      </ModelShowContext>
    </ModelContext>
  );
};
